import { Routes, Route } from "react-router-dom";
import Layout from "../Components/Layout/Layout";
import Home from "../Pages/Home";
import GroupInstruction from "../Pages/GroupInstruction";
import IndividualInstruction from "../Pages/IndividualInstruction";
import UnlimitedInstruction from "../Pages/UnlimitedInstruction";
import Detail from "../Pages/UserDashboard/Profile/Details/Detail";
import ProfileDetail from "../Pages/UserDashboard/Profile/Details/Sub-Section/ProfileDetail";
import Player from "../Pages/UserDashboard/Profile/Details/Sub-Section/Player";
import Payment from "../Pages/UserDashboard/Profile/Details/Sub-Section/Payment";
import Package from "../Pages/UserDashboard/Profile/Details/Sub-Section/Package";
import Password from "../Pages/UserDashboard/Profile/Details/Sub-Section/Password";
import MySessions from "../Pages/UserDashboard/Profile/Details/Sub-Section/MySessions";
import LoginPage from "../Pages/Authentication/login";
import Register from "../Pages/Authentication/register/Register";
import Forget from "../Pages/Authentication/Forget/Forget";
import OtpVerify from "../Pages/Authentication/OtpVerify/OtpVerify";
import ResetPassword from "../Pages/Authentication/ResetPassword/ResetPassword";
import InstructionsForm from "../Pages/InstructionsForm";
import InstructionsFormNewUser from "../Pages/InstructionsFormNewUser";
import Cart from "../Pages/Cart/Cart";
import Checkout from "../Pages/Cart/Checkout";
import TeamWorkout from "../Pages/TeamWorkout";
import SuccessStories from "../Pages/SuccessStories";
import SessionScheduled from "../Pages/Schedule/SessionScheduled";
import YourPackage from "../Pages/Schedule/YourPackage";
import ScheduleYourSessions from "../Pages/Schedule/ScheduleYourSessions";
import WeeklySchedule from "../Pages/Schedule/WeeklySchedule";
import PrivacyPolicy from "../Pages/PrivacyPolicy/PrivacyPolicy";
import TermsOfService from "../Pages/TermsOfService/TermsOfService";
import SponsorsPage from "../Pages/Sponsors";
import HowToSchedule from "../Pages/HowToSchedule";
import Teaminstructions from "../Pages/TeamInstructions";
import ContactUs from "../Pages/ContactUs";
import BasketBallSummerCamps from "../Pages/BasketBallSummerCamps";
import PaymentsFailed from "../Pages/Cart/Checkout/PaymentsFailed";
import BasketBallInstructions from "../Pages/BasketBallInstructions";
import BasketBallClicnic from "../Pages/BasketBallClicnic";
import BasketBallBday from "../Pages/BasketBallBday";
import BasketBallPrograms from "../Pages/BasketBallPrograms";
import BasketBallSummerCampsDetails from "../Pages/BasketBallSummerCampsDetails";
import BirthdayPartiesRegistration from "../Pages/BirthdayPartiesRegistration";
import Notifications from "../Pages/UserDashboard/Profile/Details/Sub-Section/NewNotify";
import ResetPasswordExisting from "../Pages/Authentication/ResetPasswordExisting/ResetPasswordExisting";
import PaymentMethod from "../Pages/UserDashboard/Profile/Details/Sub-Section/PaymentMethod";
import SummerCampRegisterPage from "../Pages/SummerCampRegister";
import SummerCampRegister from "../Pages/SummerCampRegister/SummerCampReg";
import SummerCampPaymentCheckout from "../Pages/Cart/SummerCampCheckout/SummerCampPaymentCheckout";
import SummerCampPaymentFailed from "../Pages/Cart/SummerCampCheckout/SummerCampPaymentFailed";
import Thankyou from "../Pages/PaymentAuthPages/Thankyou/Thankyou";
import PaymentVerify from "../Pages/PaymentAuthPages/PaymentVerify/PaymentVerify";
import MySummerCamp from "../Pages/UserDashboard/Profile/Details/Sub-Section/MySummerCamp";
import NotFound from "../Pages/NotFound/NotFound";


const Routing = () => {
  return (
    <Routes>

      <Route path="*" element={<NotFound />} />

      {/* Auth Routes */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/create-an-account" element={<Register />} />
      <Route path="/forgot-password" element={<Forget />} />
      <Route path="/otp-verify" element={<OtpVerify />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/thank-you" element={<Thankyou />} />
      <Route path="/payment-verify" element={<PaymentVerify />} />
      <Route
        path="/reset-password-existing"
        element={<ResetPasswordExisting />}
      />

      {/* Main Layout */}
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/group-instruction" element={<GroupInstruction />} />
        <Route
          path="/individual-instruction"
          element={<IndividualInstruction />}
        />
        <Route
          path="/unlimited-instruction"
          element={<UnlimitedInstruction />}
        />
        <Route path="/team-workout" element={<Teaminstructions />} />
        <Route path="/session-scheduled" element={<SessionScheduled />} />
        <Route path="/about/" element={<TeamWorkout />} />
        <Route
          path="/shootin-school-success-stories/"
          element={<SuccessStories />}
        />
        <Route path="/sponsors/" element={<SponsorsPage />} />
        <Route path="/how-to-schedule/" element={<HowToSchedule />} />
        <Route path="/contact/" element={<ContactUs />} />

        <Route path="/cart" element={<Cart />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/payment-failed" element={<PaymentsFailed />} />

        <Route path="/summer-camp-checkout/:user"
          element={<SummerCampPaymentCheckout />}
        />
        <Route
          path="/summer-camp-payment-failed"
          element={<SummerCampPaymentFailed />}
        />

        <Route
          path="/schedule-your-sessions"
          element={<ScheduleYourSessions />}
        />
        <Route path="/your-packages" element={<YourPackage />} />
        <Route path="/weekly-schedule" element={<WeeklySchedule />} />

        <Route
          path="/basketball-summer-camps"
          element={<BasketBallSummerCamps />}
        />
        <Route
          path="/basketball-summer-camps-details"
          element={<BasketBallSummerCampsDetails />}
        />
        <Route path="/instruction/" element={<BasketBallInstructions />} />
        <Route path="/clinics/" element={<BasketBallClicnic />} />
        <Route
          path="/birthday-parties-registration-form/"
          element={<BasketBallBday />}
        />
        <Route path="/programs/" element={<BasketBallPrograms />} />

        {/* ✅ NEW ROUTE (kept safely) */}
        <Route
          path="/birthday-parties/"
          element={<BirthdayPartiesRegistration />}
        />

        <Route path="/packages/:packageId" element={<InstructionsForm />} />
        <Route
          path="/packages-new/:packageId"
          element={<InstructionsFormNewUser />}
        />
        <Route
          path="/register-summer-camp/:id/:user"
          element={<SummerCampRegister />}
        />

        {/* PROFILE SECTION */}
        <Route path="/profile" element={<Detail />}>
          <Route index element={<ProfileDetail />} />
          <Route path="players" element={<Player />} />
          <Route path="billing" element={<Payment />} />
          <Route path="payment-methods" element={<PaymentMethod />} />
          <Route path="packages" element={<Package />} />
          <Route path="my-sessions" element={<MySessions />} />
          <Route path="password" element={<Password />} />
          <Route path="notifications" element={<Notifications />} />
          <Route path="my-summer-camp" element={<MySummerCamp/>} />
        </Route>
      </Route>
    </Routes>
  );
};

export default Routing;
